var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowSide = function SvgIconArrowSide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    fill: "none",
    viewBox: "0 0 8 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.22 6.3a.4.4 0 0 0 0-.6L2.08.5c-.17-.18-.45-.18-.6 0l-.7.7c-.17.14-.17.42 0 .6l4.15 4.18L.78 10.2a.4.4 0 0 0 0 .6l.7.7c.15.18.43.18.6 0z"
  })));
};
export default SvgIconArrowSide;